import { KatLitFilteredElement, register } from '../../shared/base';
import { KatHero } from '.';

/**
 * @component {kat-hero-extended-info} KatHeroExtendedInfo Component used display hero extended info.
 */
@register(KatHero.slotMapping.extendedInfo.name)
export class KatHeroExtendedInfo extends KatLitFilteredElement {
  constructor() {
    super(
      KatHero.slotMapping.extendedInfo.name,
      KatHero.slotMapping.extendedInfo.allowed
    );
  }
}
